"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var weight = {
  bold: '700',
  semibold: '600',
  regular: '400',
  light: '300'
};
var _default = weight;
exports["default"] = _default;